import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Conditional } from '../../components/utils';

import styles from './customers.module.scss';

export const Customers = ({ items, header, footer }) => (
	<div className={styles.wrapper}>
		<div className={styles.container}>
			{header}
			<div className={styles.items}>
				{items.map(
					(item, key) =>
						item.image.file && (
							<Conditional
								key={key}
								condition={item.url}
								wrapper={(children) => (
									<a href={item.url} target="_blank" rel="noreferrer">
										{children}
									</a>
								)}>
								<GatsbyImage
									alt={item.image.alt}
									title={item.image.title}
									image={item.image.file.childImageSharp.gatsbyImageData}
								/>
							</Conditional>
						)
				)}
			</div>
			{footer}
		</div>
	</div>
);

Customers.defaultProps = {
	items: {},
	header: null,
	footer: null,
};

Customers.propTypes = {
	items: PropTypes.array.isRequired,
	header: PropTypes.element,
	footer: PropTypes.element,
};
